import { useState, useRef, useCallback } from 'react';
import { uploadAttachment } from '../utils';

// Shared attach-file flow for the chat composer, the standalone-email compose
// modal, and the external-message inline reply form.
const useAttachmentUpload = ({ onError } = {}) => {
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [attachment, setAttachment] = useState(null);

  const handleFileSelect = useCallback(
    async e => {
      const file = e.target.files?.[0];
      if (fileInputRef.current) fileInputRef.current.value = '';
      if (!file) return;
      setUploading(true);
      if (onError) onError(null);
      try {
        const uploaded = await uploadAttachment(file);
        setAttachment(uploaded);
      } catch (err) {
        if (onError) {
          onError(
            err?.error?.message || err?.message || 'Upload failed. Please try again.',
          );
        }
      } finally {
        setUploading(false);
      }
    },
    [onError],
  );

  return {
    fileInputRef,
    uploading,
    setUploading,
    attachment,
    setAttachment,
    handleFileSelect,
  };
};

export default useAttachmentUpload;
